import { z, type infer as zInfer } from "zod";

export const GAME_SESSION_STATUSES = {
  ACTIVE: "ACTIVE",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
  COMPLETED: "COMPLETED",
} as const;

export const gameSessionStatus = z.enum(GAME_SESSION_STATUSES);

export const gameSession = z.object({
  gameId: z.uuid(),
  gameSessionStatus: gameSessionStatus,
  url: z.url(),
});

export type GameSession = zInfer<typeof gameSession>;
